import {
    Pipe,
    PipeTransform,
} from '@angular/core';

@Pipe({ name: 'nl2br' })
export class Nl2BrPipe implements PipeTransform {
    transform(value: string) {
        return value ?
            value
                .replace(/\r\n/g, '<br/>')
                .replace(/\r/g, '<br/>')
                .replace(/\n/g, '<br/>')
            :
            null;
    }
}
